import { Box } from '@mui/system';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { url } from 'src/Helpers/utils/Constant';
import ModalsWrapper from 'src/components/Modals/ModalsWrapper';
import UpdateRenewalApplication from './UpdateRenewalApplication';
import { ISingleRenewalApplication } from 'src/Types/module/applications/applications';

type IProps = {
  application: ISingleRenewalApplication;
  loading: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setApplication: React.Dispatch<
    React.SetStateAction<ISingleRenewalApplication>
  >;
};
const UpdateModal = ({
  setShowModal,
  showModal,
  loading,
  setLoading,
  application,
  setApplication,
}: IProps) => {
  const [inputs, setInputs] = useState({
    renewal_application_status: 'pending',
    renewal_application_reject_reason: '',
  });

  useEffect(() => {
    setInputs({
      renewal_application_status: application.renewal_application_status,
      renewal_application_reject_reason:
        application.renewal_application_reject_reason,
    });
  }, []);

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();

    try {
      const response = await axios.patch(
        `${url}/api/member/renewal-application/${application.renewal_application_id}`,
        inputs
      );

      setLoading(false);
      if (response.data.success) {
        alert('Application updated');
        setApplication({
          ...application,
          renewal_application_status: inputs.renewal_application_status,
          renewal_application_reject_reason:
            inputs.renewal_application_reject_reason,
        });
        setShowModal(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <ModalsWrapper
      setShowModal={setShowModal}
      showModal={showModal}
      modalData={{
        title: 'Update renewal application',
      }}
    >
      <Box px={2}>
        <UpdateRenewalApplication
          application={application}
          setShowModal={setShowModal}
          setApplication={setApplication}
        />
      </Box>
    </ModalsWrapper>
  );
};

export default UpdateModal;
